import { useTranslation } from 'react-i18next';

import bg_text_area from '../../assets/svgs/BG-text-area.svg';
import bg from '../../assets/svgs/BG-up.svg';
import SupportButton from '../UI/SupportButton';

import classes from './Home.module.scss';

export default function BeforeLogin() {
  const { t, i18n } = useTranslation('mainpage');
  const language = i18n.language;

  return (
    <>
      <img src={bg} alt="" className={classes.bg} />
      <section className={classes.body}>
        <div className={`${classes['text-area']} ${classes[language]}`}>
          <h1>{t('title')}</h1>
          <p>{t('description')}</p>
        </div>
      </section>
      <img src={bg_text_area} alt="" className={classes.bg_text_area} />
      <SupportButton />
    </>
  );
}
